<template>
  <v-container>
    <current-user-can permission="editConditions">
      <rest-resource-table
        label="Condition Options"
        resource-name="Conditiononpracticevalues"
        resource-id-name="conditionid"
        @saved="$store.dispatch('LOAD_CONFIG')"
        @select="getAssignedPeopleCount"
        allow-new
        :allow-delete="numberUsers === 0"
        :columns="columnHeaders"
        edit-permission="editConditions"
        view-permission="viewConditions"
      >
        <template v-slot:item.papercertificate="{ item }">
          <div>
            <v-simple-checkbox
              disabled
              :value="item.papercertificate"
            ></v-simple-checkbox>
          </div>
        </template>
        <template v-slot:item.isconfidential="{ item }">
          <div>
            <v-simple-checkbox
              disabled
              :value="item.isconfidential"
            ></v-simple-checkbox>
          </div>
        </template>
        <template v-slot:item.inactive="{ item }">
          <div>
            <v-simple-checkbox
              disabled
              :value="item.inactive"
            ></v-simple-checkbox>
          </div>
        </template>

        <template v-slot:form="{ item }">
          <v-textarea
            v-model="item.conditiondescription"
            label="Description"
            rows="1"
            auto-grow
          />
          <v-layout>
            <v-row>
              <v-col>
                <v-checkbox
                  label="Paper Certificate"
                  v-model="item.papercertificate"
                />
              </v-col>
              <v-col>
                <v-checkbox
                  label="Is Confidential"
                  v-model="item.isconfidential"
                />
              </v-col>
              <v-col>
                <v-checkbox label="Inactive" v-model="item.inactive" />
              </v-col>
            </v-row>
          </v-layout>

          <em v-if="numberUsers !== null">
            Currently assigned to
            <strong>
              {{ numberUsers }}
              {{ numberUsers === 1 ? "person" : "people" }}
            </strong>
          </em>
        </template>
      </rest-resource-table>
    </current-user-can>
  </v-container>
</template>

<script>
import restResourceTable from "@/components/lib/RestResourceTable.vue";

export default {
  name: "AdminConditions",
  components: {
    restResourceTable
  },
  data() {
    return {
      numberUsers: null,
      columnHeaders: [
        { text: "ID", value: "conditionid" },
        { text: "Description", value: "conditiondescription" },
        { text: "Paper Certificate", value: "papercertificate" },
        { text: "isconfidential", value: "isconfidential" },
        { text: "inactive", value: "inactive" }
      ]
    };
  },
  methods: {
    async getAssignedPeopleCount(cond) {
      this.numberUsers = null;

      if (!cond || !cond.conditionid) {
        return;
      }

      const { data } = await this.$http.get(
        "conditionsonscopeofpractice/active/count",
        {
          params: { where: { conditionid: cond.conditionid } }
        }
      );
      this.numberUsers = data.count;
    }
  }
};
</script>
